import { memo } from 'react';

import { Skeleton } from '@air/component-skeleton';

export type WorkspaceAgentActionsMenuListRowSkeletonLayout = 'catalog' | 'search';

export type WorkspaceAgentActionsMenuListRowSkeletonProps = {
  layout: WorkspaceAgentActionsMenuListRowSkeletonLayout;
};

export const WorkspaceAgentActionsMenuListRowSkeleton = memo(
  ({ layout }: WorkspaceAgentActionsMenuListRowSkeletonProps) => {
    if (layout === 'search') {
      return (
        <div className="flex w-full items-center gap-2 rounded-6 px-2 py-2">
          <Skeleton className="h-4 min-w-0 max-w-[70%] flex-1" isText />
          <Skeleton className="h-3 w-14 shrink-0" isText />
        </div>
      );
    }

    return (
      <div className="flex w-full flex-col gap-1 rounded-6 p-1.5">
        <div className="flex items-baseline gap-2">
          <Skeleton className="h-4 min-w-0 max-w-[55%] flex-1" isText />
          <Skeleton className="h-3 w-14 shrink-0" isText />
        </div>
        <Skeleton className="h-4 w-[85%]" isText />
      </div>
    );
  },
);

WorkspaceAgentActionsMenuListRowSkeleton.displayName = 'WorkspaceAgentActionsMenuListRowSkeleton';
